<template>
    <fieldset class="select-languages co-fieldset">
        <div class="co-fieldset-inner">
            <section id="select_languages" class="sl-grid">
                <div class="sl-source-col">
                    <h3>Source</h3>
                    <label>
                        <span class="co-label"
                            >Source Language
                            <span class="co-asterisk">*</span></span
                        >
                        <v-select
                            dusk="select-languages-source-language-component"
                            label="description"
                            placeholder="Choose Type"
                            name="type"
                            class="co-custom-arrow"
                            :clearable="false"
                            :value="formState.selectLanguages.source_language"
                            :reduce="(lang) => lang.id"
                            :options="formState.selectLanguages.source_languages"
                            @input="updateSource"
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"
                                    ><chevron-down-icon :size="24"
                                /></span>
                            </template>
                            <!-- This is primarily for testing purposes -->
                            <template #option="{ id, description }">
                                <span :data-dusk="description">{{
                                    description
                                }}</span>
                            </template>
                        </v-select>
                    </label>
                </div>

                <div class="sl-target-col">
                    <div class="sl-target-language">
                        <h3>Target</h3>
                        <label class="co-label">Target Language</label>
                        <a
                            v-if="!showAllLanguages"
                            id="show-all-target-langs"
                            class="sl-tl-option"
                            @click="showAllLanguages = true"
                            >Show all</a
                        >
                        <a
                            v-else
                            class="sl-tl-option"
                            id="hide-target-langs"
                            @click="showAllLanguages = false"
                            >Hide</a
                        >
                        <a
                            v-if="hasLanguageSet"
                            id="save-language-set"
                            class="sl-tl-option"
                            @click="confirmSaveLanguageSet()"
                            >Save As Language Set</a
                        >
                        <a
                            v-if="hasLanguageSet"
                            id="clear-language-set"
                            class="sl-tl-option"
                            @click="clearTargetLanguages()"
                            >Clear All</a
                        >
                        <multiselect
                            dusk="select-languages-target-language-component"
                            id="target-language"
                            v-model="formState.selectLanguages.target_languages"
                            placeholder="Target Language"
                            label="description"
                            track-by="id"
                            class="co-custom-arrow"
                            :options="this.formState.selectLanguages.user_languages"
                            :multiple="true"
                            :taggable="false"
                        >
                            <span slot="noResult"
                                >Language pair not supported. Please contact
                                your project manager.</span
                            >
                            <template #caret="{ toggle }" :toggle="toggle">
                                <chevron-down-icon
                                    :size="24"
                                    @mousedown.prevent.stop="toggle()"
                                    class="multiselect__select"
                                />
                            </template>
                            <template
                                slot="option"
                                slot-scope="{ option, search }"
                            >
                                <span :data-dusk="option.description">{{
                                    option.description
                                }}</span>
                            </template>
                        </multiselect>
                    </div>

                    <section class="sl-all-languages" v-show="showAllLanguages">
                        <header>
                            <span
                                >Available Target Languages (click to add)</span
                            >
                            <span
                                @click="showAllLanguages = false"
                                class="clickable"
                                >Hide</span
                            >
                        </header>
                        <ul>
                            <li v-for="ul in userLanguages">
                                <a
                                    class="clickable"
                                    @click="addLanguages([ul])"
                                    >{{ ul.description }}</a
                                >
                            </li>
                        </ul>
                    </section>
                    <section class="language-sets">
                        <transition name="fade">
                            <div
                                class="co-form-error"
                                v-show="targetLanguageError"
                            >
                                {{ targetLanguageError }}
                            </div>
                        </transition>
                        <acclaro-accordian
                            id="my-language-set-header"
                            :title="'<strong>My Language Sets</strong>'"
                            :is-active="true"
                        >
                            <ul class="ls-items">
                                <li
                                    class="ls-item"
                                    v-for="languageSet in language_sets"
                                >
                                    <div
                                        class="ls-item-inner"
                                        v-if="!isDeletedSet(languageSet.id)"
                                    >
                                        <div class="ls-item-btn">
                                            <button
                                                v-on:click="
                                                    addLanguages(
                                                        languageSet.languages
                                                    )
                                                "
                                                type="button"
                                                class="ls-item-btn ls-addlang-btn"
                                            >
                                                <plus-icon
                                                    title="add language set"
                                                    :size="15"
                                                    fillColor="#fff"
                                                /><span>Add</span>
                                            </button>
                                        </div>
                                        <div class="ls-lang-name">
                                            <acclaro-inline-edit
                                                :save-url="
                                                    '/languages/sets/' +
                                                    languageSet.id
                                                "
                                                :text="
                                                    languageSet.name ||
                                                    'Unnamed'
                                                "
                                            />
                                        </div>
                                        <ul class="ls-item-opts">
                                            <li
                                                v-for="language in languageSet.languages"
                                                class="ls-item-langauge"
                                            >
                                                {{ language.description }}
                                            </li>
                                            <li
                                                @click="
                                                    deleteLanguageSet(
                                                        languageSet
                                                    )
                                                "
                                                class="ls-item-icon"
                                            >
                                                <trash-can-outline-icon
                                                    title="delete language set"
                                                    :size="18"
                                                    fillColor="#0069AA"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="ls-item-undo" v-else>
                                        <span>Language Set Deleted</span>
                                        <button
                                            type="button"
                                            @click="
                                                undoDeleteLanguageSet(
                                                    languageSet.id
                                                )
                                            "
                                            class="ls-item-btn ls-undo-btn"
                                        >
                                            <span>undo</span>
                                        </button>
                                        <close-icon
                                            title="close"
                                            @click="
                                                removeLanguageSet(
                                                    languageSet.id
                                                )
                                            "
                                            class="ls-item-closebtn"
                                            fillColor="#333"
                                            :size="18"
                                        />
                                    </div>
                                </li>
                            </ul>
                        </acclaro-accordian>
                        <acclaro-accordian
                            :title="`<strong>Company</strong> Language Sets`"
                            :is-active="true"
                        >
                            <ul class="ls-items">
                                <li
                                    class="ls-item"
                                    v-for="languageSet in account_language_sets"
                                >
                                    <div
                                        class="ls-item-inner"
                                        v-if="!isDeletedSet(languageSet.id)"
                                    >
                                        <div class="ls-item-btn">
                                            <button
                                                v-on:click="
                                                    addLanguages(
                                                      languageSet.languages
                                                    )
                                                "
                                                type="button"
                                                class="ls-item-btn ls-addlang-btn"
                                            >
                                                <plus-icon
                                                    title="add languages"
                                                    :size="15"
                                                    fillColor="#fff"
                                                /><span>Add</span>
                                            </button>
                                        </div>
                                        <div class="ls-lang-name">
                                            <span>{{ languageSet.name }}</span>
                                        </div>
                                        <ul class="ls-item-opts">
                                            <li
                                                v-for="language in languageSet.languages"
                                                class="ls-item-langauge"
                                            >
                                                {{ language.description }}
                                            </li>
                                            <li
                                                class="ls-item-icon non-clickable"
                                            >
                                                <lock-icon
                                                    title="locked"
                                                    :size="18"
                                                    fillColor="#333"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </acclaro-accordian>
                    </section>
                </div>
            </section>
        </div>
    </fieldset>
</template>

<script>
import "./style.scss";
import {
    InformationOutlineIcon,
    TrashCanOutlineIcon,
    PlusIcon,
    LockIcon,
    CloseIcon,
    ChevronDownIcon,
} from "../../icons.js";
import { mapState, mapActions, mapGetters } from "vuex";
import {isEmpty} from "lodash";

export default {
    props: {
        userId: {
            type: [String, Number],
            required: true,
        },

        selectLanguageOptionsUrl: {
            type: String,
            default: "/create-order/select-languages/options",
        },

        saveLangaugeSetUrl: {
            type: String,
            default: "/languages/sets/store",
        },

        /**
         * @note /languages/sets/delete/${languageSetId}
         */
        deleteLanguageSetUrl: {
            type: String,
            default: "/languages/sets/delete/",
        },
    },
    mounted() {
      this.getSourceLanguages().then(async (sourceLanguages) => {
            let source_language = this.formState.selectLanguages.source_language;
            let targets = []
            let target_language = await this.getSelectLanguagesOptions().then(options => options.target_language);
            targets.push(target_language);

          //update the source language
          this.updateSource(source_language).then(() => {
            this.$nextTick(() => {
              //set order target languages if any
              targets.forEach(langId => {
                let language = this.userLanguages.find(ul => ul.id == langId);

                if (language) {
                  this.formState.selectLanguages.target_languages.push(language);
                }
              });
            })
          });
        });
        this.loadLanguageSets();
    },
    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),

        ...mapState({
            source_language: (state) =>
                state.CreateProgramStore.selectLanguages.source_language,
        }),

        ...mapGetters("CreateProgramStore", [
            "userLanguageSets",
            "userLanguages",
            "accountLanguageSets",
            "sourceLanguages",
        ]),

        /**
         * getter/setter for target languages
         *
         */
        target_languages: {
            get() {
                return this.formState.selectLanguages.target_languages;
            },

            set(value) {
                this.updateTargetLanguages(value);
            },
        },

        /**
         * Get source language object
         *
         * @return Object {code, description, id, tgt}
         */
        sourceLanguage() {
            if (!this.formState.selectLanguages.source_language) return {};
            return (
                this.formState.selectLanguages.source_languages.find(
                    (lang) => lang.id == this.formState.source_language
                ) || {}
            );
        },

        /**
         * Check if user has seleted any target languages
         *
         * @return Boolean
         */
        hasLanguageSet() {
            return this.formState.selectLanguages.target_languages.length > 0;
        },

        /**
         * Get an array of user langauge sets
         *
         * @return array [Object]
         */
        language_sets() {
            return this.formState.selectLanguages.user_language_sets.map(
                (langSet) => {
                    let { data: langIds } = langSet;

                    langIds = langIds.split(",");

                    let languages =
                        this.formState.selectLanguages.user_languages.filter(
                            (lang) => langIds.includes(lang.id.toString())
                        );

                    return Object.assign({}, langSet, { languages });
                }
            );
        },

        /**
         * Get an array of account langauge sets
         *
         * @return array [Object]
         */
        account_language_sets() {
            if (isEmpty(this.formState.selectLanguages.account_language_sets))
                return [];

            return this.formState.selectLanguages.account_language_sets.map(
                (langSet) => {
                    let { data: langIds } = langSet;

                    langIds = langIds.split(",");

                    let languages =
                        this.formState.selectLanguages.user_languages.filter(
                            (lang) => langIds.includes(lang.id.toString())
                        );

                    return Object.assign({}, langSet, { languages });
                }
            );
        },
    },

    methods: {
        ...mapActions("CreateProgramStore", [
            "updateSourceLanguage",
            "updateSourceLanguageDescription",
            "updateTargetLanguages",
            "getUserLanguageSets",
            "getAccountLanguageSets",
            "getTargetLanguages",
            "getSourceLanguages",
        ]),

        /**
         * Get Select Lanugages Options
         *
         */
        getSelectLanguagesOptions() {
            return axios
                .get(this.selectLanguageOptionsUrl)
                .then((result) => result.data);
        },

        /**
         * Check if this languageset has been deleted
         *
         */
        isDeletedSet(id) {
            return isEmpty(this.deletedLanguageSets[id]) === false;
        },

        /**
         * Add langauges to target languages
         *
         */
        addLanguages(languageSet) {
          console.log(languageSet);
            let languageResult =
                this.formState.selectLanguages.target_languages;
            let alreadySelectedCount = 0;

            languageSet.forEach((language) => {
                let alreadySelected =
                    this.formState.selectLanguages.target_languages.find(
                        (obj) => obj.code == language.code
                    );

                if (!alreadySelected) {
                    this.formState.selectLanguages.target_languages.push(
                        language
                    );
                } else {
                    alreadySelectedCount++;
                }
            });

            //check if all the target languages have already been added
            if (alreadySelectedCount == languageSet.length) {
                this.targetLanguageError =
                    "Selected target language(s) already added.";

                //clear error
                setTimeout(() => {
                    this.targetLanguageError = "";
                }, 2000);
            }
        },

        /**
         * Get language sets
         *
         */
        loadLanguageSets() {
            let getUserLanguageSets = this.getUserLanguageSets(
                this.userId
            ).then((result) => {
                //empty deleted language sets
                this.deletedLanguageSets = {};

                return result;
            });

            let getAccountLanguageSets = this.getAccountLanguageSets(
                window.backend.account
            );

            return Promise.all([getUserLanguageSets, getAccountLanguageSets]);
        },

        /**
         * Delete Language Set
         *
         */
        deleteLanguageSet(languageSet) {
            let data = {
                target_language_ids: languageSet.languages.map((s) => s.id),
                source_language_id: this.formState.source_language,
                name: languageSet.name,
            };

            return axios
                .delete(deleteLanguageSetUrl + $languageSet.id)
                .then(() => {
                    //set the language set to deleted
                    this.$set(
                        this.deletedLanguageSets,
                        languageSet.id,
                        languageSet
                    );

                    //remove language set permanently in 5 seconds
                    let timeout = setTimeout(() => {
                        //check if this should still be deleted ( user hasn't undone it )
                        if (this.isDeletedSet(languageSet.id)) {
                            this.removeLanguageSet(languageSet.id);
                        }
                    }, 5000);

                    //add timeout to timeouts object
                    //so we can clear it later if a user clicks undo
                    this.$set(this.timeouts, languageSet.id, timeout);
                });
        },

        /**
         * undo deletion of language set
         *
         */
        undoDeleteLanguageSet(id) {
            let languageSet = this.deletedLanguageSets[id];

            //re-save the deleted language set
            return this.saveLanguageSet({
                target_language_ids: languageSet.languages.map((s) => s.id),
                source_language_id: this.formState.source_language,
                name: languageSet.name,
            }).then(() => {
                //remove languageSet from deleted set
                this.$set(this.deletedLanguageSets, languageSet.id, undefined);

                //clear timeout
                if (this.timeouts[languageSet.id]) {
                    clearTimeout(this.timeouts[languageSet.id]);

                    this.$delete(this.timeouts, languageSet.id);
                }

                //load language set
                //this.loadLanguageSets()
            });
        },

        /**
         * permanently remove language set from list of language sets
         *
         */
        removeLanguageSet(id) {
            let indx = this.language_sets.findIndex(
                (languageSet) => languageSet.id == id
            );

            //delete langauge set and let Vue know
            this.$delete(this.language_sets, indx);

            //remove languageSet from deleted set
            this.$set(this.deletedLanguageSets, id, undefined);
        },

        /**
         * Clear All Target Languages
         *
         */
        clearTargetLanguages() {
            this.target_languages = [];
        },

        /**
         * close language set Modal
         *
         */
        closeLanguageSetModal() {
            this.$modal.hide("language_set_modal");
            this.languageSetName = "";
        },

        /**
         * Save users langauge set
         *
         */
        saveLanguageSet(languageSet) {
            let data = Object.assign(
                { user_id: parseInt(this.userId) },
                languageSet
            );

            return axios({
                method: "post",
                url: this.saveLangaugeSetUrl,
                data,
            }).then((result) => {
                this.closeLanguageSetModal();
            });
        },

        /**
         * Set modals 'language set name' from user input
         *
         */
        setLanguageSetName($event) {
            this.languageSetName = $event.target.value;

            let nameTaken = this.language_sets.find(
                (lang) =>
                    lang.name.toLowerCase() ==
                    this.languageSetName.toLowerCase()
            );

            this.languageSetError = nameTaken ? true : false;
        },

        /**
         * update source language
         * and language sets
         *
         */
        updateSource(sourceLanguageId) {
            const prevSourceLangId = this.formState.source_language;

            this.updateSourceLanguage(sourceLanguageId);
            this.updateSourceLanguageDescription(
                this.sourceLanguage.description
            );

            return new Promise((resolve, reject) => {
                this.getTargetLanguages().then((languages) => {
                    this.loadLanguageSets();

                    if (prevSourceLangId !== sourceLanguageId) {
                        this.clearTargetLanguages();
                    }

                    resolve();
                });
            });
        },

        /**
         * show dialog to save a new language set
         *
         */
        confirmSaveLanguageSet() {
            this.$modal.show(
                {
                    name: "language_set_modal",

                    template: `
            <section class="create-order-modal">
              <header class="co-modal-header">
                <h1>Add Language Set</h1>
              </header>
              <div class="co-modal-content">
                <p>Please name your new Language set</p>
                <input id="language-set-name" :maxlength="100" placeholder="Enter Language Set Name..." name="language_set_name" @input="updateName" />
                <span v-if="hasError()" class="co-modal-error">Duplicate Language Set name</span>
              </div>
              <div class="co-modal-footer two-btns">
                <button @click="save()" :disabled="isDisabled()" class="popup-confirm-btn btn-primary">Ok</button>
                <button @click="cancel()" class="popup-cancel-btn btn-secondary co-cancel-btn"">Cancel</button>
              </div>
            </section>`,

                    props: [
                        "updateName",
                        "isDisabled",
                        "save",
                        "cancel",
                        "hasError",
                    ],
                },
                {
                    /**
                     * Set modals 'language set name' from user input
                     *
                     */
                    updateName: this.setLanguageSetName,

                    hasError: () => {
                        return this.languageSetError;
                    },

                    save: () => {
                        let target_language_ids = this.target_languages.map(
                            (t) => t.id
                        );

                        if (this.languageSetError)
                            return console.error("language taken");

                        this.saveLanguageSet({
                            target_language_ids,
                            source_language_id: this.formState.selectLanguages.source_language,
                            name: this.languageSetName,
                        }).then(() => this.loadLanguageSets());
                    },
                    cancel: this.closeLanguageSetModal,
                    isDisabled: () =>
                        this.languageSetName.length < 2 ||
                        this.languageSetError,
                },
                {
                    width: 450,
                    height: 200,
                    name: "language_set_modal",
                }
            );
        },
    },

    data() {
        let selected = Object.assign({}, this.selected);

        return {
            account: window.backend.account,
            isVisible: false,
            showAllLanguages: false,
            languageSetError: false,
            languageSetName: "",
            targetLanguageError: "",
            selectedItem: selected,
            deletedLanguageSets: {},
            timeouts: {},
        };
    },

    components: {
        InformationOutlineIcon,
        TrashCanOutlineIcon,
        PlusIcon,
        LockIcon,
        CloseIcon,
        ChevronDownIcon,
    },

    directives: {},
};
</script>
